export const apiwebUrl = "https://servicios.campus.pe/"